const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNTEyIDM0MiI+CjxyZWN0IHk9IjAiIGZpbGw9IiMyNzI3MjciIHdpZHRoPSI1MTIiIGhlaWdodD0iMTE0Ii8+CjxyZWN0IHk9IjExNCIgZmlsbD0iI2U0MDExMiIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIxMTQiLz4KPHJlY3QgeT0iMjI4IiBmaWxsPSIjMDc4OTNmIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjExNCIvPgo8Y2lyY2xlIGZpbGw9IiNlNDAxMTIiIGN4PSIyNTYiIGN5PSIxMjUiIHI9Ijk1Ii8+Cjwvc3ZnPgo=";
export {
  I as default
};
//# sourceMappingURL=MW-e65d1590.mjs.map
